import React from 'react';
import servicesData from '../data/servicesData';
import '../styles/ServiceDetail.css';

const ServiceDetail = ({ serviceSlug }) => {
  const service = servicesData.find((item) => item.slug === serviceSlug);
  const backToServiceHref = service ? `/#service-card-${service.slug}` : '/#services';

  const handleBackToServices = (event) => {
    event.preventDefault();

    if (service) {
      sessionStorage.setItem('scrollToServiceCard', service.slug);
      window.location.href = '/#services';
      return;
    }

    window.location.href = '/#services';
  };

  if (!service) {
    return (
      <section className="service-detail">
        <div className="service-detail-container">
          <div className="service-detail-card">
            <div className="service-detail-content">
              <h1 className="service-detail-title">Service Not Found</h1>
              <p className="service-detail-text">The requested service detail is not available.</p>
              <div className="service-detail-actions">
                <a href="/#services" className="service-back-btn" onClick={handleBackToServices}>Back to Our Services</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="service-detail">
      <div className="service-detail-container">
        <div className="service-detail-card">
          <img
            src={`/images/${encodeURIComponent(service.image)}`}
            alt={service.title}
            className="service-detail-image"
            onError={(event) => {
              event.currentTarget.src = '/images/airport.jpg';
            }}
          />

          <div className="service-detail-content">
            <h1 className="service-detail-title">{service.title}</h1>
            <p className="service-detail-text">{service.details}</p>

            <div className="service-detail-actions">
              <a
                href="https://booktaxinow.co.uk/"
                target="_blank"
                rel="noopener noreferrer"
                className="service-detail-btn"
              >
                Book This Service
              </a>
              <a href={backToServiceHref} className="service-back-btn" onClick={handleBackToServices}>Back to Our Services</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceDetail;